import { render, staticRenderFns } from "./FarewellComponent.vue?vue&type=template&id=3224f553&scoped=true&"
import script from "./FarewellComponent.vue?vue&type=script&lang=js&"
export * from "./FarewellComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224f553",
  null
  
)

export default component.exports